import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { FindComplaint, ComplaintInfo } from "pages"
import { COMPONENTS } from 'Constants'


const HomePage: React.FC<any> = ({ }) => {
  const [currentComponent, setCurrentComponent] = useState(COMPONENTS.FindComplaint)
  return <>
    {currentComponent === COMPONENTS.FindComplaint && <FindComplaint setCurrentComponent={setCurrentComponent} />}
    {currentComponent === COMPONENTS.ComplaintInfo && <ComplaintInfo />}
  </>

}
export default withTranslation()(withRouter(HomePage));